


<div class="d-flex justify-content-between align-items-center">
  <ngx-spinner></ngx-spinner>
</div>
<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
  <div class="row">
    <div class="col-12"></div>
    <div class="col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <!-- ngx-datatable-filter -->
            <fieldset class="form-group">
              <div class="row">
                <!-- <div class="col-12 col-sm-12 col-md-12 col-lg-6 mb-2"> -->
                <div class="col-12 col-sm-12 col-md-12 col-lg-4 mb-2">
                  <div class="btn-group enrollment-list-btn-info" role="group">
                    <div *ngFor="let status of enrollment_status" >
                      <button  *ngIf="(empType.includes('Teacher') && (status?.name === 'Classroom' || status?.name === 'Online')) || !empType.includes('Teacher')"
                      id="status-btns" type="button" class="btn"
                      [ngClass]="{'btn-primary': status?.name ==='Pending' || status?.name ==='Classroom' || status?.name ==='Online' || status?.name ==='Completed' ,'btn-outline-primary':activeTab !==status?.name && activeTab !==status?._id }"
                      (click)="activeEnrollmentTab(status?._id,status?.name,0)">{{status?.name}}</button>
                  
                    </div>
                        <div class="col-12">
                  <button *ngIf="guideline_data" class="small-button" (click)="openDynamicModal(guideline_data)">Enrollment Guideline</button>
                  <button type="button" class="small-button" (click)="importExcel()">Export to Excel</button>
                  </div>
                    
                    <!-- <button type="button" class="btn cursor-pointer"
                      [ngClass]="{'btn-primary':activeTab=='pending','btn-outline-primary':activeTab!='pending'}"
                      (click)="activeEnrollmentTab(activeTab=='pending'?'':'pending')">Pending</button>
                    <button type="button" class="btn cursor-pointer"
                      [ngClass]="{'btn-primary':activeTab=='enrolled','btn-outline-primary':activeTab!='enrolled'}"
                      (click)="activeEnrollmentTab(activeTab=='enrolled'?'':'enrolled')">Enrolled</button>
                    <button type="button" class="btn cursor-pointer"
                      [ngClass]="{'btn-primary':activeTab=='completed','btn-outline-primary':activeTab!='completed'}"
                      (click)="activeEnrollmentTab(activeTab=='completed'?'':'completed')">Completed</button> -->
                    <!-- <button type="button" class="btn" [ngClass]="{'btn-primary':activeTab=='due','btn-outline-primary':activeTab!='due'}"  (click)="activeEnrollmentTab(activeTab=='due'?'':'due')"> Due fees</button>
                    <button type="button" class="btn" [ngClass]="{'btn-primary':activeTab=='pendingFees','btn-outline-primary':activeTab!='pendingFees'}"  (click)="activeEnrollmentTab(activeTab=='pendingFees'?'':'pendingFees')">Pending fees</button> -->
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-4 col-lg-2 mb-2">
                  <!-- <button  class="btn btn-primary" (click)="dueFeesModal()">Due Fees</button> -->
                </div>

                <div class="col-12 col-sm-12 col-md-8 col-lg-6 mb-2">
                  <div class="row-flex">
                    <!-- <div class="col-flex-2 mb-1">
                      <div class="dropdown btn-group dropup mr-1 mb-1" ngbDropdown>
                        <button type="button" class="btn btn-outline-primary btn2">{{selected_huntingId}}</button>
                        <button type="button" class="btn btn-outline-primary dropdown-toggle" ngbDropdownToggle
                          aria-haspopup="true" aria-expanded="false">
                          <span class="sr-only">Toggle Dropdown</span>
                        </button>
                        <div ngbDropdownMenu class="dropdown-menu" role="menu">
                          <button class="dropdown-item" *ngFor="let item of hunting_List"
                            (click)="getHuntId(item?._id,item.name)">{{item.name}}</button>
                        </div>
                      </div>
                    </div> -->
                    <div class="col-flex-2 mb-1 position-relative">
                      <!-- <label for="ngx-filter-ref">Search -->
                      <input id="ngx-filter-ref"
                        class="form-control form-control-sm d-inline-block width-cs-300 rounded-right shadow searchInput"
                        type="text" (keydown.enter)="getEnrolmentFilter(searchVal)"
                        placeholder="Name/Email/Phone/College" #name [(ngModel)]="searchVal" />
                      <!-- </label> -->
                      <button class="btn search-btn glow position-absolute" (click)="getEnrolmentFilter(searchVal)">
                        <i class="ft-search text-white cursor-pointer"></i>
                      </button>
                    </div>
                    <div class="col-flex-2 mb-1">
                      <button class="btn btn-primary btn-block users-list-clear glow mb-0" (click)="resetFilter()">Reset
                        <i class="ft-filter text-white cursor-pointer"></i>
                      </button>
                    </div>
                    <div class="col-flex-2 mb-1"
                      *ngIf=" user_role.roles ==='admin' || user_role.roles ==='employee' || user_role.roles ==='extractor'">
                      <button type="reset" class="btn btn-primary btn-block users-list-clear glow mb-0"
                        routerLink="/enrollments/enrollment-create" placement="top" ngbTooltip="Add New">
                        <i class="ft-plus text-white cursor-pointer"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 pagination-body header-body mb-2">
                  <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="40"
                    [footerHeight]="40" rowHeight="auto" [limit]="limitRef" [rows]="rows" [externalPaging]="true"
                    [count]="page.totalPages" [offset]="page.pageNumber"
                    (page)="pageChangeData($event,activeTab)"></ngx-datatable>
                </div>
                
                <!-- <div>
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                    <label for="file-upload" class="btn btn-primary btn-block users-list-clear glow mb-0">Upload file</label>
                      <input type="file" accept=".csv" id="file-upload" (change)="onSelectFileCSV($event)"/>
                  </div>
                </div> -->
              </div>
            </fieldset>
            <!-- Collapsible Filter Section -->
            <div class="filter-collapse-container mb-2">
              <button class="btn btn-outline-secondary btn-sm mb-1" (click)="showFilters = !showFilters">
                <span *ngIf="!showFilters">Show More Filters &#9660;</span>
                <span *ngIf="showFilters">Hide Filters &#9650;</span>
              </button>
              <div *ngIf="showFilters">
                <!-- Enrollment Tag Filters -->
                <div class="mb-2 d-flex flex-wrap align-items-center">
                  <span 
                    *ngFor="let tag of enrollmentTags" 
                    class="badge badge-pill mr-2 mb-2 cursor-pointer"
                    [ngClass]="{'badge-primary': selectedEnrollmentTagId === tag._id, 'badge-light': selectedEnrollmentTagId !== tag._id}"
                    (click)="onTagChipClick(tag)"
                    style="font-size: 14px;"
                  >
                    {{ tag.displayname }} 
                  </span>
                  <span *ngIf="selectedEnrollmentTagId" class="ml-2 cursor-pointer text-danger" (click)="clearTagFilter()">Clear</span>
                </div>
                <!-- Position Tag Filters -->
                <div class="mb-2 d-flex flex-wrap align-items-center">
                  <span 
                    *ngFor="let tag of positionsIags_list" 
                    class="badge badge-pill mr-2 mb-2 cursor-pointer"
                    [ngClass]="{'badge-primary': selectedPositionTagId === tag._id, 'badge-light': selectedPositionTagId !== tag._id}"
                    (click)="onPositionTagChipClick(tag)"
                    style="font-size: 14px;"
                  >
                    {{ tag.displayname }} 
                  </span>
                  <span *ngIf="selectedPositionTagId" class="ml-2 cursor-pointer text-danger" (click)="clearPositionTagFilter()">Clear</span>
                </div>
                <!-- Relationship Tag Filters -->
                <div class="mb-2 d-flex flex-wrap align-items-center">
                  <span 
                    *ngFor="let tag of studentRelationshipTags" 
                    class="badge badge-pill mr-2 mb-2 cursor-pointer"
                    [ngClass]="{'badge-primary': selectedRelationshipTagId === tag._id, 'badge-light': selectedRelationshipTagId !== tag._id}"
                    (click)="onRelationshipTagChipClick(tag)"
                    style="font-size: 14px;"
                  >
                    {{ tag.displayname }} 
                  </span>
                  <span *ngIf="selectedRelationshipTagId" class="ml-2 cursor-pointer text-danger" (click)="clearRelationshipTagFilter()">Clear</span>
                </div>
                  <!-- Due Fees Filters -->
                <div class="mb-2 d-flex flex-wrap align-items-center">
                  <span 
                    class="badge badge-pill mr-2 mb-2 cursor-pointer"
                    [ngClass]="{'badge-primary': isDuedatefeesFilter, 'badge-light': !isDuedatefeesFilter}"
                    (click)="onDuedatefeesFilter()"
                    style="font-size: 14px;"
                  >
                    {{ 'Fees Due or Payment Overdue' }} 
                  </span>
                  <span *ngIf="isDuedatefeesFilter" class="ml-2 cursor-pointer text-danger" (click)="clearDuedatefeesFilter()">Clear</span>
                </div>
                 <!-- joining date and not verified Filters -->
                <div class="mb-2 d-flex flex-wrap align-items-center">
                  <span 
                    class="badge badge-pill mr-2 mb-2 cursor-pointer"
                    [ngClass]="{'badge-primary': isJoiningOverNotVerifiedFilter, 'badge-light': !isJoiningOverNotVerifiedFilter}"
                    (click)="onJoiningOverNotVerifiedFilter()"
                    style="font-size: 14px;"
                  >
                    {{ 'Joined but Not Verified' }} 
                  </span>
                  <span *ngIf="isJoiningOverNotVerifiedFilter" class="ml-2 cursor-pointer text-danger" (click)="clearJoiningOverNotVerifiedFilter()">Clear</span>
                </div>
              </div>
            </div>
            <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="50"
              [footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows" [scrollbarH]="true"
              [columns]="columns" [externalPaging]="false" [count]="page.totalPages" [offset]="page.pageNumber"
              >
              <ngx-datatable-column name="Name" prop="name">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <div class="d-flex align-items-center mb-1" *ngIf="row?.enrollNo">
                    <span class="font-weight-bold mr-2">Enroll No:</span>
                    <span class="mr-2 text-info">{{ row?.enrollNo }}</span>
                    <button type="button" class="btn btn-sm p-0" (click)="copySerialNo(row?.enrollNo)" ngbTooltip="Copy Enroll No">
                      <i class="ft-copy"></i>
                    </button>
                  </div>
                  <div class="d-flex align-items-center">
                  <div class="avatar-img-hover">
                    <img class="rounded-circle mr-1" *ngIf="row?.user_id?.image" [src]="imageUrl + row?.user_id?.image" height="32"
                      width="32" />
                    <div *ngIf="!row?.user_id?.image" class="avatar mr-1 ml-0 bg-primary">
                      <div class="avatar-content">{{ row?.name | shortName }}</div>
                       <!-- Performer "P" Badge at Top-Left -->
 <span class="star-badge"
  [title]="row?.students?.isperformer === 'yes' ? 'A Performer' : 'Not A Performer'"
  (click)="openModal(myModal, row, 'myModal')"
  [ngClass]="{
    'performer': row?.students?.isperformer === 'yes',
    'not-performer': row?.students?.isperformer === 'no'
  }"
>
  {{ row?.students?.isperformer === 'yes' ? '★' : '☆' }}
</span>

                    </div>
                    <!-- --------- card ------------------------------------ -->
                    <div  class="card-overlay-on-hover">
                      <div class="card">
                        <div class="card-content">
                          <div class="card-img">
                            <img *ngIf="row?.user_id?.image" class="card-img-top img-fluid" [src]="imageUrl + row?.user_id?.image"
                              alt="Card image cap">
                            <div *ngIf="!row?.user_id?.image" class="avatarImg mr-1 ml-0 bg-primary">
                              <div class="avatar-contentImg">{{ row?.name | shortName }}</div>
                            </div>
                          </div>
                          <div class="card-body p-0">
                            <h4>{{row?.name}}</h4>
                            <p *ngIf="!empType.includes('Teacher')">{{row?.email}}</p>
                            <p>{{row?.college?.name}}</p>
                            <p *ngIf="!empType.includes('Teacher')">{{row?.phone}}</p>
                             <div class="d-flex align-items-center mb-1" *ngIf="row?.user_id?.serialNo">
                    <span class="font-weight-bold mr-2">Serial No:</span>
                    <span class="mr-2 text-info">{{ row?.user_id?.serialNo }}</span>
                    <button type="button" class="btn btn-sm p-0" (click)="copySerialNo(row?.user_id?.serialNo)" ngbTooltip="Copy Serial No">
                      <i class="ft-copy"></i>
                    </button>
                  </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- ---------------------------------------------------------- -->
                  </div>

                    <div class="cell-line-height cursor-pointer">
                      <p class="font-medium-1 line-height-1 mb-0">
                        {{ row?.name }} 
                        <span style="position: absolute;" *ngIf="student?.isperformer =='yes'"><img src="assets/tick-parple-clr.svg" alt=""></span>
                      </p>
                      <span *ngIf="row?.mentor_id[0]?.user[0]?._id" class="badge badge-pill bg-light-info cursor-pointer" (click)="openMentorBuddyModal(myModalReferral,row?._id,row?.mentor_id[0]?.user[0]?._id,'Mentor')" placement="top" ngbTooltip="Mentor">
                        {{row?.mentor_id[0]?.user[0]?.name}}
                      </span>
                      <span *ngIf="!row?.mentor_id[0]?.user[0]?._id" (click)="openMentorBuddyModal(myModalReferral,row?._id,'','Mentor')" placement="top" ngbTooltip="Add Mentor">
                        <i class="ft-plus cursor-pointer text-primary"></i>
                      </span><br>
                      
                
                      
                      <span *ngIf="row?.last_qualification" class="my-2 mx-1">{{row?.last_qualification}}</span>
                      <span *ngIf="row?.qualification_year" class="my-2 mx-1">{{row?.qualification_year}}</span><br/>
                           <!-- Enrollment Tags -->
                      <div class="enrollment-tags-container mt-1">
                        <div *ngIf="row?.enrollment_tags && row?.enrollment_tags.length > 0" class="d-flex flex-wrap">
                          <span *ngFor="let tag of row?.enrollment_tags" 
                                class="badge badge-pill mr-1 mb-1 cursor-pointer"
                                [title]="getEnrollmentTagName(tag)"
                                (click)="openEnrollmentTagsModal(enrollmentTagsModal, row)">
                            {{ getEnrollmentTagName(tag) }}
                          </span>
                        </div>
                        <div class="enrollment-tags-add"
                             (click)="openEnrollmentTagsModal(enrollmentTagsModal, row)"
                             [title]="'Click to add Enrollment Tags'">
                          <i class="ft-plus text-muted"></i>
                        </div>
                      </div>
                    </div>
                     
                    
                  </div>
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column *ngIf="activeTab === 'pending'" name="Course Interest"
                prop="coursecatinterest_id.displayname">
              </ngx-datatable-column>
              <ngx-datatable-column *ngIf="activeTab === 'pending'">
                <ng-template let-column="column" ngx-datatable-header-template>
                  Skill
                </ng-template>
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <div class="hover-txt-show">
                    <span *ngFor=" let item of row?.skillsinterest_id | slice:0:2">{{item.displayname}} </span>
                  </div>
                  <!-- --------- card ------------------------------------ -->
                  <div class="hover-txt-show-bottom">
                    <div class="card">
                      <div class="card-content">
                        <div class="card-body p-0">
                          <span class="mr-2" *ngFor=" let item of row?.skillsinterest_id">{{item.displayname}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- ---------------------------------------------------------- -->
                </ng-template>

              </ngx-datatable-column>

              <ngx-datatable-column *ngIf="activeTab === 'Classroom' || activeTab === 'Online' || activeTab === 'enrolled' || activeTab === 'completed'" name="Course Name" prop="course_id">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <!-- Course Name and Edit Button -->
                  {{ row?.course_id?.title }} <span *ngIf="row?.course_id?.duration?.displayname">| {{ row?.course_id?.duration?.displayname }}</span>
                  <button
                    class="btn btn-link btn-sm p-0 ml-1"
                    (click)="openModalCourseUpdate(courseUpdateModal, row)"
                    title="Edit Course"
                  >
                    <i class="fa fa-pencil"></i>
                  </button>
                  <br>
                  <!-- Batch Display and Edit Button (unchanged) -->
                  <span *ngIf="row?.batch_id?.name" class="badge badge-pill bg-light-primary my-1 cursor-pointer" ngbTooltip="Batch" placement="top" (click)="openModalBatchUpdate(batchUpdateModal,row)">
                    {{row?.batch_id?.name}}
                  </span>
                  <span *ngIf="!row?.batch_id?.name">
                    <i class="ft-plus-circle text-primary cursor-pointer my-1"
                      (click)="openModalBatchUpdate(batchUpdateModal,row)" ngbTooltip="Add Batch" placement="top"></i>
                  </span>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column *ngIf="activeTab === 'pending'" name="Date of Registration" prop="created_at">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  {{row?.created_at | date }} 
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column *ngIf="!empType.includes('Teacher') && activeTab === 'Classroom' || activeTab === 'Online' ||activeTab === 'enrolled'" name="Fees" prop="pendingAmount" width="20">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <span *ngIf="row?.pendingAmount !== null && row?.pendingAmount !== undefined"
  class="badge badge-pill mb-1"
  [ngClass]="row.pendingAmount > 0 ? 'bg-light-danger' : 'bg-light-success'"
  title="Pending Amount">
  ₹{{ row.pendingAmount || 0 }}
</span>
<span
  class="badge rounded-pill text-dark mx-1 mb-1"
  [ngClass]="(row?.total_due ?? 0) > 0 ? 'bg-light-warning' : 'bg-light-success'"
  [title]="'Total Due: ₹' + (row?.total_due ?? 0)">
  ₹{{ row?.total_due ?? 0 }}
</span>

<span
  class="badge rounded-pill text-dark mx-1"
  [ngClass]="(row?.remaining_not_due < 0 || row?.remaining_not_due == 0) ? 'bg-light-success' : 'bg-light-warning'"
  [title]="'Remaining Not Due: ₹' + (row?.remaining_not_due ?? 0)">
  ₹{{ row?.remaining_not_due ?? 0 }}
</span>

                      
                      <span *ngIf="row?.buddy_id[0]?.user[0]?._id" class="badge badge-pill bg-light-info cursor-pointer my-1" (click)="openMentorBuddyModal(myModalReferral,row?._id,row?.buddy_id[0]?.user[0]?._id,'Buddy')" placement="top" ngbTooltip="Buddy">
                        {{row?.buddy_id[0]?.user[0]?.name}}
                      </span>
                      <span *ngIf="!row?.buddy_id[0]?.user[0]?._id" class="my-1" (click)="openMentorBuddyModal(myModalReferral,row?._id,'','Buddy')" placement="top" ngbTooltip="Add Buddy">
                        <i class="ft-plus cursor-pointer text-primary"></i>
                      </span>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column *ngIf="activeTab === 'Classroom' || activeTab === 'Online' ||activeTab === 'enrolled' " name="Date of Joining" prop="course_id" width="20">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  {{row?.date_of_joining | date: "mediumDate"}}
                  <button class="btn btn-link p-0" (click)="openDateOfJoiningModal(dateOfJoiningModal, row)"><i class="ft-edit text-primary"></i></button> <br>
                  <span class="badge badge-pills bg-light-info mt-1 cursor-pointer"  mat-button [matMenuTriggerFor]="menuPosition">
                    {{row?.position?.displayname}}
                  </span>
                  <mat-menu #menuPosition="matMenu">
                    <div *ngFor="let item of positionsIags_list">
                      <button mat-menu-item *ngIf="item.displayname !== row?.position?.displayname" (click)="updatePosition(row?._id,item._id)">{{item.displayname}}</button>
                    </div>
                    
                  </mat-menu>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column *ngIf="activeTab === 'pending'" name="Reference By" prop="user_id">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  {{row?.user_id?.refrence?.name}}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column *ngIf="activeTab === 'Classroom' || activeTab === 'Online' ||activeTab === 'enrolled' " name="Referral By" prop="refrence_id" [width]="20">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <p *ngIf="row?.refrence_id?.length>0; else  notRefrence_id" class="cursor-pointer" (click)="openReferralModal(myModalReferral,row?._id,row?.refrence_id[0]._id)">{{row?.refrence_id[0]?.name}}</p> 
                  <ng-template #notRefrence_id>
                    <i  class="ft-plus-circle text-primary cursor-pointer  mx-1" (click)="openReferralModal(myModalReferral,row?._id,'')"></i>
                  </ng-template>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column *ngIf="activeTab === 'pending'" name="Notes" prop="notes">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <p class="notes-content">{{row?.notes}}</p>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column *ngIf="activeTab === 'Classroom' || activeTab === 'Online' ||activeTab === 'enrolled' || activeTab === 'completed'"
                name="Status" prop="status" width="20">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <div class="d-flex flex-column">
                    <div class="badge badge-pill text-capitalize mb-1"
                      [ngClass]="{'bg-light-primary': row?.status === 'left', 'bg-light-success':row?.status === 'enrolled'|| row?.status === 'completed', 'bg-light-danger':row?.status === 'pending','bg-light-info':row?.status === 'cancel'} ">
                      {{row?.status}}
                    </div>
                    <!-- Student Relationship Tag -->
                    <div class="student-relationship-tag" 
                         [ngClass]="{'has-tag': row?.student_relationship_tag}"
                         (click)="openStudentRelationshipModal(studentRelationshipModal, row)"
                         [title]="row?.student_relationship_tag ? (row?.student_relationship_tag?.displayname || row?.student_relationship_tag?.name) : 'Click to add Student Relationship'">
                      <span *ngIf="row?.student_relationship_tag; else noTag">
                        {{row?.student_relationship_tag?.displayname || row?.student_relationship_tag?.name}}
                      </span>
                      <ng-template #noTag>
                        <i class="ft-plus text-muted"></i>
                      </ng-template>
                    </div>
                  </div>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column *ngIf="activeTab === 'Classroom' || activeTab === 'Online' ||activeTab === 'enrolled' || activeTab === 'completed'"
                name="Schedule" prop="batch_schedule" width="20">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <span *ngIf="!row?.batch_schedule" class="my-1" (click)="openScheduleModal(batchScheduleModal,row?._id,'add schedule')" placement="top" ngbTooltip="Add Schedule">
                    <i class="ft-plus cursor-pointer text-primary"></i>
                  </span>
                  <span class="cursor-pointer" (click)="openScheduleModal(batchScheduleModal,row?._id,'update schedule')" placement="top" ngbTooltip="Update Schedule">
                    {{row?.batch_schedule?.displayname}}
                  </span> 
                </ng-template>
               </ngx-datatable-column>

              <ngx-datatable-column name="Position" prop="position" *ngIf="activeTab === 'completed'">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <span class="badge badge-pills bg-light-info mt-1 cursor-pointer"  mat-button [matMenuTriggerFor]="menuPosition">
                    {{row?.position?.displayname}}
                  </span>
                  <mat-menu #menuPosition="matMenu">
                    <div *ngFor="let item of positionsIags_list">
                      <button mat-menu-item *ngIf="item.displayname !== row?.position?.displayname" (click)="updatePosition(row?._id,item._id)">{{item.displayname}}</button>
                    </div>
                  </mat-menu>
                </ng-template>
              </ngx-datatable-column>
            <ngx-datatable-column name="Verified">
  <ng-template let-row="row" ngx-datatable-cell-template>
    <mat-slide-toggle
      color="primary"
      class="toggle-switch"
      [checked]="row?.isVerified"
      (change)="toggleVerification(row)">
    </mat-slide-toggle><br>
         <span *ngIf="(row?.remaining_not_due > 0) || (row?.total_due > 0) || (row?.pendingAmount > 0)" [title]="'Next Payment Date'" [ngClass]="{ overdue: isOverdue(row?.next_payment_date) }">{{row?.next_payment_date | date: 'mediumDate'}}</span>
         <button class="btn btn-link p-0" (click)="openNextPaymentDateModal(nextPaymentDateModal, row)"><i class="ft-edit text-primary"></i></button> <br>
  </ng-template>
</ngx-datatable-column>


              <ngx-datatable-column  [name]="activeTab === 'Classroom' || activeTab === 'Online' ||activeTab==='enrolled'?'Actions':'Actions'"
                *ngIf=" user_role.roles ==='admin' || user_role.roles ==='employee' || user_role.roles ==='extractor'">
                <ng-template let-row="row" ngx-datatable-cell-template>

                <div class="d-flex ">
                  <i *ngIf="row?.status === 'pending'" mat-button [matMenuTriggerFor]="menu"
                    class="ft-more-vertical text-primary cursor-pointer mr-2"></i>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item [routerLink]="['/enrollments/enrollment-edit', row._id]">Process</button>
                    <button *ngIf="user_role.roles==='admin' || user_type === 'HR'" mat-menu-item
                      (click)="statusUpdate(row._id,row)">Cancel</button>
                  </mat-menu>
                  <i *ngIf="!empType.includes('Teacher') && row?.status === 'enrolled'" mat-button [matMenuTriggerFor]="menu1"
                    class="ft-more-vertical text-primary cursor-pointer mr-2"></i>
                   
                    
                       <mat-menu #menu1="matMenu">
                    <button mat-menu-item (click)="openContent(row._id)">Add Fees</button>
                    <button mat-menu-item  (click)="viewEnroll(row)">Manage</button>

                    <button *ngIf="user_role.roles==='admin' || user_role.roles==='employee'" mat-menu-item (click)="statusUpdate(row._id,row)">Candidate
                      Left</button>
                    <button *ngIf="user_role.roles==='admin' || user_role.roles==='employee'" mat-menu-item (click)="statusUpdate2(row._id,row)">Course
                      Completed</button>
                    <button mat-menu-item *ngIf="user_role.roles==='admin'" (click)="sendMail(row?.email)">
                      Send Email
                    </button> 
                    <button mat-menu-item *ngIf="!empType.includes('Teacher') && activeTab === 'Classroom' || activeTab === 'Online'" (click)="openModalForReferral(myModalContentReferral,row?.user_id?._id,row?.user_id?.name)">
                      Add Referral
                    </button>
                  

                  </mat-menu>
                  <i *ngIf="row?.status !== 'pending' && row?.status !== 'enrolled'" mat-button
                    [matMenuTriggerFor]="menu2" class="ft-more-vertical text-primary cursor-pointer mx-1"></i>
                    <i *ngIf="row?.status !== 'pending' && row?.status !== 'enrolled'" class="ft-settings cursor-pointer mx-1"
                    [ngClass]="{'text-gry':row?.students?.isperformer ==='no','text-primary':row?.students?.isperformer ==='yes'}" placement="bottom"
                    ngbTooltip="performer" (click)="openModal(myModal,row,'myModal')"></i>
                    <i *ngIf="row?.status !== 'pending' && row?.status !== 'enrolled'" class="ft-aperture cursor-pointer mx-1" 
                    [ngClass]="{'text-gry':!row?.students?.placement_business,'text-primary':row?.students?.placement_business}" placement="bottom"
                    ngbTooltip="placement" (click)="openModal(myModal1,row,'myModal1')"></i>
                    <i *ngIf="row?.status === 'enrolled'" mat-button [matMenuTriggerFor]="menuNew"
                    class="ft-settings text-primary cursor-pointer mr-2"></i>
                    <mat-menu #menuNew="matMenu" id="newMenu">
                      <button mat-menu-item *ngIf="empType.includes('Teacher') || empType.includes('Managment') || user_role.roles==='admin'" (click)="openModal(myModal,row,'myModal')">
                  
                        Performer
                      </button>
                      <button mat-menu-item *ngIf="row?.status === 'enrolled'" (click)="openModal(myModal1,row,'myModal1')">
                    
                        Placement
                      </button>
                      <button mat-menu-item *ngIf="row?.status === 'enrolled'" (click)="viewEnrollReport(row)">
                
                        Teacher Report
                      </button>
                      <button mat-menu-item *ngIf="!empType.includes('Teacher') && row?.status === 'enrolled'" (click)="openInNewTab(row.course_id._id,row.user_id._id)">
                       
                        View Lms
                      </button>   
                      <button *ngIf="user_role.roles==='admin' || empType.includes('Teacher')" mat-menu-item
                        (click)="assignmentByStudent(row?.user_id?._id)">Assignment</button>
                      <button mat-menu-item
                        *ngIf="user_role.roles==='admin' || empType.includes('Teacher') && row?.status === 'enrolled'"
                        (click)="openContentProjectAssign(myModalProjectAssign,row._id,row.project_assign?row.project_assign:'')">
                        Project Assign
                      </button>
                      <button mat-menu-item
                      *ngIf="user_role.roles==='admin' || empType.includes('Teacher') || empType.includes('Managment') || empType.includes('HR')  && row?.status === 'enrolled'" (click)="openModalForOnboarding(myModalOnboarding,row)">
                        Onboarding Details
                      </button>
                     
                    </mat-menu> 
                    <span *ngIf="activeTab !=='Online' && activeTab !=='Classroom'">
                    <span *ngIf="row?.next_action?.displayname" ngbTooltip="next action" placement="top">
                      (<span class="cursor-pointer mx-1 my-1" (click)="openModalForAction(myModalContent,row)">{{row?.next_action?.displayname}}</span>)
                    </span> 
                    <span *ngIf="!row?.next_action?.displayname" ngbTooltip="next action" placement="top">
                      (<span class="cursor-pointer mx-1 my-1"
                        (click)="openModalForAction(myModalContent,row)"><i class="ft-plus text-primary cursor-pointer"></i></span>)
                    </span>
                      <span *ngIf="row?.last_activedate" ngbTooltip="next action date" placement="top" class="cursor-pointer mx-1">{{row?.last_activedate | date:'mediumDate'}}</span>
                      </span>
                  <mat-menu #menu2="matMenu">
                    <button mat-menu-item (click)="viewEnroll(row)">Manage</button>

                    <button mat-menu-item *ngIf="row?.status === 'cancel'" (click)="confirmUpdateStatus(row?._id,row?.status)">Move to Pending</button>
                    <button mat-menu-item *ngIf="row?.status === 'left'" (click)="confirmUpdateStatus(row?._id,row?.status)">Move to Enrolled</button>
                    <button mat-menu-item *ngIf="row?.status === 'completed'" (click)="confirmUpdateStatus(row?._id,row?.status)">Move to Enrolled</button>
                  </mat-menu>
                     
                    <div class="mx-1 my-1" *ngIf="row?.status === 'enrolled' || row?.status === 'completed' " (click)="openCheclistPopup(checklistModal,row?.sprint[0]?.data,row?.sprint[0]?._id)">
                      <span class="cursor-pointer" *ngIf="row?.sprint"> {{ row?.sprint[0]?.true_sprint_count}}/{{row?.sprint[0]?.sprint_count}}</span>
                    </div>  
                                 <!-- Student Notes -->
                    <i class="ft-file-text text-info cursor-pointer mx-1"
                       ngbTooltip="Edit Notes"
                       (click)="openNotesModal(notesModal, row, 'notes')"></i>

                    <!-- Admin Notes -->
                    <i class="ft-user text-warning cursor-pointer mx-1"
                       ngbTooltip="Edit Admin Notes"
                       (click)="openNotesModal(notesModal, row, 'admin_notes')"></i>

                    <!-- Payment Notes -->
                    <i class="ft-credit-card text-success cursor-pointer mx-1"
                       ngbTooltip="Edit Payment Notes"
                       (click)="openNotesModal(notesModal, row, 'payment_notes')"></i>

                  

                </div>
                  
                </ng-template>

              </ngx-datatable-column>
              
            </ngx-datatable>
      
            <!-- ngx-datatable-filter -->
          </div>
        </div>
      </div>
    </div>
  </div>

</section>
<!--/ Filter Datatables -->

<!---------- Performer Popup ---------------->
<div>
	<ng-template #myModal let-modal>
		<div class="modal-header">
			<h4 class="modal-title">Performer Update</h4>
			<button type="button" class="close" (click)="modal.dismiss()">
				<span>&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<form>
				<div class="form-group">
					<label>Is Performer</label>
          <ng-select
            [items]="performer_list"
            bindLabel="name"
            color="is_activated"
            bindValue="id"
            placeholder="Select Performer"
            [(ngModel)]="performer_event"
            [ngModelOptions]="{ standalone: true }"
            (change)="selectPerformer($event)" 
           >
          </ng-select>
				</div>
			</form>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
			<button type="button" class="btn btn-primary" (click)="submit()">Submit</button>
		  </div>
	</ng-template>
</div>

<!---------- Placement Popup ---------------->
<div>
	<ng-template #myModal1 let-modal>
		<div class="modal-header">
			<h4 class="modal-title">Placement Info Update</h4>
			<button type="button" class="close" (click)="modal.dismiss()">
				<span>&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<form>
        <div class="d-flex align-items-center mb-2">
          <img *ngIf="!imgUrl && placement_data.user_id.image" class="rounded-circle mr-1" [src]="imageUrl + placement_data.user_id.image" alt=""  width="32" height="32" >
          <img *ngIf="imgUrl" [src]="imgUrl"alt="user edit avatar" class="rounded-circle mr-1 object-fit-cover" width="42" height="42" />
          <div *ngIf="!imgUrl&&!placement_data.user_id.image" class="avatar mr-1 ml-0 bg-primary">
            <div class="avatar-content">{{ placement_data.user_id.name | shortName }}</div>
          </div>
          <div class="btn-box">
            <label class="btn btn-sm btn-primary mb-1 mb-sm-0 text-transform-unset">Change
              <input type="file"#fileInput class="form-control" (change)="onSelectFile($event)" hidden />
            </label>
          </div>
        </div>

        <div class="form-group">
					<label>Name<span class="required_field">*</span></label>
					<input type="text" class="form-control" [(ngModel)]="placement_data.user_id.name" [ngModelOptions]="{standalone: true}" readonly>
				</div>
        <div class="form-group">
					<label>Email<span class="required_field">*</span></label>
          <input type="email" class="form-control" [(ngModel)]="placement_data.user_id.email" [ngModelOptions]="{standalone: true}" readonly>
				</div>
        <div class="form-group">
					<label>Phone<span class="required_field">*</span></label>
					<input type="text" class="form-control" [(ngModel)]="placement_data.user_id.phone" [ngModelOptions]="{standalone: true}" readonly>
				</div>
      
        <div class="form-group">
					<label>LinkedIn/Resume</label>
					<input type="text" class="form-control" [(ngModel)]="placement_model.linkedIn" [ngModelOptions]="{standalone: true}">
				</div>
        <div class="form-group">
					<label>Bio<span class="required_field">*</span></label>
					<input type="text" class="form-control" [(ngModel)]="placement_model.bio" [ngModelOptions]="{standalone: true}"  ngModel #bio="ngModel"
          id="bio" name="bio" required>
          <small class="form-text text-muted danger"
            *ngIf="!bio.valid && (bio.dirty || bio.touched)">
            Bio is required!
          </small>
				</div>
        <div class="form-group">
					<label>Placement Business<span class="required_field">*</span></label>
					<ng-select
            [items]="collegeList"
            bindLabel="name"
            color="is_activated"
            bindValue="_id"
            placeholder="Select College"
            [(ngModel)]="selectedCollege"
            [ngModelOptions]="{ standalone: true }"
            (change)="getCollegeId($event)" 
            ngModel #placement_id="ngModel" id="placement_id" name="placement_id" required>
          </ng-select>
        </div>
        <div class="form-group">
					<label>Placement Info<span class="required_field">*</span></label>
					<textarea class="form-control" name="" id="" cols="30" rows="3" [(ngModel)]="placement_model.placementinfo" [ngModelOptions]="{standalone: true}"
          ngModel #placementinfo="ngModel" id="placementinfo" name="placementinfo" required></textarea>
          <small class="form-text text-muted danger"
            *ngIf="!placementinfo.valid && (placementinfo.dirty || placementinfo.touched)">
            Placementinfo is required!
          </small>
        </div>
       
			</form>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
			<button type="button" class="btn btn-primary" [disabled]="!bio.valid || !placementinfo.valid || !placement_id.valid" (click)="updatePlacement()">Submit</button>
		  </div>
	</ng-template>
</div>

<!---------- CheckList  Popup ---------------->
<div>
	<ng-template #checklistModal let-modal>
		<div class="modal-header">
			<h4 class="modal-title">Checklist Update</h4>
			<button type="button" class="close" (click)="modal.dismiss()">
				<span>&times;</span>
			</button>
		</div>
		<div class="modal-body">
      <div *ngFor="let item of key_Values; let i = index" class="key-value-input d-flex">
        <!-- <input class="input-key" type="text" placeholder="Key" [(ngModel)]="item[0]" name="key_{{i+1}}" [ngModelOptions]="{ standalone: true }"> -->
        <input class="input-value mr-1" type="checkbox" placeholder="Value" [(ngModel)]="item[1]" name="value_{{i+1}}" [ngModelOptions]="{ standalone: true }">

        <label>{{item[0]}}</label>
        
       
      </div>
    </div>
    <div class="modal-footer">
			<button type="button" class="btn btn-primary" (click)="updateCheck()">Submit</button>
			<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>

		  </div>
  </ng-template>
</div>

<!------------- Popup For Next_Action --------------------------------------->
<div>
  <ng-template #myModalContent>
    <div class="modal-header">
      <h4 class="modal-title">{{next_action_name}}'s Next Action</h4>
      <button type="button" class="close" aria-label="Close" (click)="modalService.dismissAll()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label>Next Action</label>
        <ng-select [items]="nextactionList" bindLabel="displayname" bindValue="_id" placeholder="Select next action"
          [(ngModel)]="next_action_model.next_action" [ngModelOptions]="{standalone: true}" (change)="getChangeNextAction($event)">
        </ng-select>
      </div>
      <div class="form-group">
        <label>Notes</label>
        <textarea class="form-control" [(ngModel)]="next_action_model.notes"  name="notes" id="notes" cols="30" rows="2"></textarea>
      </div>
      <div class="form-group">
        <label>Next Action Date</label>
        <input class="form-control" type="date" [(ngModel)]="next_action_model.last_activedate"
          [ngModel]="this.next_action_model.last_activedate | date: 'yyyy-MM-dd'">
      </div>
      <div class="form-group">
        <label>Last Response</label>
        <input class="form-control" type="text" [(ngModel)]="next_action_model.lastresponse">
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Close</button>
      <button type="button" class="btn btn-primary" (click)="nextActionUpdate()">Save changes</button>
    </div>
  </ng-template>
</div>

<!---------- Add Referral  Popup ---------------->
<div>
	<ng-template #myModalReferral let-modal>
		<div class="modal-header">
			<h4 class="modal-title" *ngIf="selected_emp_referral && !selected_mentor_buddy && !modalFor">Referral Update</h4>
			<h4 class="modal-title" *ngIf="!selected_emp_referral && !selected_mentor_buddy && !modalFor">Referral Add</h4>
      <h4 class="modal-title" *ngIf="selected_mentor_buddy && !selected_emp_referral && modalFor">{{modalFor}} Update</h4>
			<h4 class="modal-title" *ngIf="!selected_mentor_buddy && !selected_emp_referral && modalFor">{{modalFor}} Add</h4>
			<button type="button" class="close" (click)="modal.dismiss()">
				<span>&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<form>
				<div class="form-group" *ngIf="!modalFor">
					<label>Referral By</label>
          <ng-select
            [items]="emp_List"
            bindLabel="name"
            color="is_activated"
            bindValue="_id"
            placeholder="Select Referral"
            [(ngModel)]="selected_emp_referral"
            [ngModelOptions]="{ standalone: true }"
            (change)="selectEmpReferralId($event)" 
            [appendTo]="'body'" [virtualScroll]="true" [clearSearchOnAdd]="true"
           >
          </ng-select>
				</div>
        <div class="form-group" *ngIf="modalFor">
					<label>{{modalFor}}</label>
          <ng-select
            [items]="emp_List"
            bindLabel="name"
            color="is_activated"
            bindValue="_id"
            placeholder="Select"
            [(ngModel)]="selected_mentor_buddy"
            [ngModelOptions]="{ standalone: true }"
            (change)="mentorBuddyId($event)" 
            [appendTo]="'body'" [virtualScroll]="true" [clearSearchOnAdd]="true"
           >
          </ng-select>
				</div>
			</form>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
			<button *ngIf="!modalFor" type="button" class="btn btn-primary" (click)="referralUpdate()">Submit</button>
      <button *ngIf="modalFor" type="button" class="btn btn-primary" (click)="mentroBuddyUpdate()">Submit</button>
		  </div>
	</ng-template>
</div>
<!------------- Referral Popup --------------------------------------->
<div>
	<ng-template #myModalContentReferral>
	  <div class="modal-header">
		<h4 class="modal-title">{{row_name}}'s Referral</h4>
		<button type="button" class="close" aria-label="Close" (click)="modalService.dismissAll()">
		  <span aria-hidden="true">&times;</span>
		</button>
	  </div>
	  <div class="modal-body">
      <fieldset class="form-group" >
				<label>Report To</label>
				<ng-select
				[items]="emp_list"
				bindLabel="name"
				bindValue="user._id"
				[closeOnSelect]="true"
				placeholder="Select"
				[(ngModel)]="referral_model.report_to"
				[ngModelOptions]="{ standalone: true }"
				(change)="getEmpId($event)"
			  ></ng-select>
			  </fieldset>
			  <fieldset class="form-group">
          <label>Notes</label>
          <textarea
          [(ngModel)]="referral_model.notes"
            id="hidden-label-form-6"
            rows="3"
            class="form-control"
            name="notes"
            placeholder="Enter notes"
          ></textarea>
        </fieldset>
        <fieldset class="form-group">
          <label>Admin Notes</label>
          <textarea
          [(ngModel)]="referral_model.admin_notes"
            id="hidden-label-form-6"
            rows="3"
            class="form-control"
            name="admin_notes"
            placeholder="Enter admin notes"
          ></textarea>
        </fieldset>
	  </div>
	  <div class="modal-footer">
		<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Close</button>
		<button type="button" class="btn btn-primary" (click)="addReferral()">Submit</button>
	  </div>
	</ng-template>
</div>

<div>
	<ng-template #myModalProjectAssign>
	  <div class="modal-header">
		<h4 class="modal-title">Project Assign</h4>
		<button type="button" class="close" aria-label="Close" (click)="modalService.dismissAll()">
		  <span aria-hidden="true">&times;</span>
		</button>
	  </div>
	  <div class="modal-body">
      <fieldset class="form-group" >
				<label>Projects</label>
				<ng-select
  [items]="project_list"
  bindValue="_id"
  [closeOnSelect]="true"
  placeholder="Select Project"
  [(ngModel)]="selected_project"
  [ngModelOptions]="{ standalone: true }"
  (change)="getProjectId($event)"
  [appendTo]="'body'"
  [virtualScroll]="true"
  [clearSearchOnAdd]="true"
>
  <!-- Custom display for dropdown items -->
  <ng-template ng-option-tmp let-item="item">
    {{ item.name }} - {{ item.status[0] }}
  </ng-template>

  <!-- Custom display for selected item -->
  <ng-template ng-label-tmp let-item="item">
    {{ item.name }} - {{ item.status[0] }}
  </ng-template>
</ng-select>
			</fieldset>
	  </div>
	  <div class="modal-footer">
		<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Close</button>
		<button type="button" class="btn btn-primary" (click)="projectAssign()">Submit</button>
	  </div>
	</ng-template>
</div>
<!---------- Batch Update Popup ---------------->
<div>
  <ng-template #batchUpdateModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title" *ngIf="!select_batch">Add Batch</h4>
      <h4 class="modal-title" *ngIf="select_batch">Update Batch</h4>  
      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <fieldset class="my-1">
        <label>Batch<span class="required_field">*</span></label>
        <ng-select [items]="batch_list" bindLabel="name" bindValue="_id" placeholder="Select Batch"
          [(ngModel)]="select_batch" [ngModelOptions]="{ standalone: true }" [closeOnSelect]="true"
          (change)="getBatchId($event)" [appendTo]="'body'" [virtualScroll]="true">
        </ng-select>
      </fieldset>
    </div>
    <div class="modal-footer">
      <button class="btn btn-primary" (click)="updateBatch()">Submit</button>
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
    </div>
  </ng-template>
</div>

<!-- Batch Schedule  -->
 
<!---------- Batch Update Popup ---------------->
<div>
  <ng-template #batchScheduleModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title" *ngIf="prop_value==='add schedule'">Add Batch Schedule</h4>
      <h4 class="modal-title" *ngIf="prop_value==='update schedule'">Update Batch Schedule</h4>  
      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <fieldset class="my-1">
        <label class="form-control-label" for="batch">Batch Schedule</label>
        <ng-select [items]="batchSchedule_list" bindLabel="displayname" bindValue="_id"
          placeholder="Select Batch Schedule" [(ngModel)]="selectedBatch_schedule" [ngModelOptions]="{ standalone: true }"
          (change)="getBatchScheduleId($event)" [appendTo]="'body'" [virtualScroll]="true">
        </ng-select>
      </fieldset>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
      <button class="btn btn-primary" (click)="updateBatchSchedule()">Submit</button>

    </div>
  </ng-template>
</div>

<!------------- Popup For Onboarding --------------------------------------->
<div>
  <ng-template #myModalOnboarding>
    <div class="modal-header">
      <h4 class="modal-title" *ngIf="onboarding_data">{{onboarding_data?.student_id[0]?.name}}'s Onboarding</h4>
      <button type="button" class="close" aria-label="Close" (click)="modalService.dismissAll()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" *ngIf="onboarding_data">
     
        
      <table>
        <tr>
          <td><b>Name :</b></td>
          <td>&nbsp;{{onboarding_data?.student_id[0]?.name}}</td>
        </tr>
        <tr>
          <td><b>About :</b></td>
          <td>&nbsp;{{onboarding_data?.about}}</td>
        </tr>
        <tr>
          <td><b>Resume :</b></td>
          <td>&nbsp;{{onboarding_data?.resume}} 
            <span>
              <a  [href]="onboarding_data?.resume" target="_blank">
                <i class="ft-external-link text-primary cursor-pointer mx-1" [hidden]="!onboarding_data?.resume" placement="left"
                  ngbTooltip="Go to resume link : {{onboarding_data?.resume}}"></i>
                </a>
            </span>
          </td>
        </tr>
        <tr>
          <td><b>LinkedIn :</b></td>
          <td>&nbsp;{{onboarding_data?.linkedIn}}
            <span>
              <a (click)="gotoLink(onboarding_data?.linkedIn)">
                <i class="ft-external-link text-primary cursor-pointer mx-1" [hidden]="!onboarding_data?.linkedIn" placement="left"
                  ngbTooltip="Go to linkedIn link : {{onboarding_data?.linkedIn}}"></i>
                </a>
            </span>
          </td>
        </tr>
        <tr>
          <td style="width: 132px"><b>Student Empowerment :</b></td>
          <td>{{onboarding_data?.is_interested === true ? 'Yes' : 'No'}}</td>
        </tr>
      </table>
      </div>
      <div class="modal-body" *ngIf="!onboarding_data">
        <p style="color: red;">Data not found!</p>
      </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Close</button>
    </div>
  </ng-template>
</div>

<!------------- Popup For Next Payment Date --------------------------------------->
<div>
  <ng-template #nextPaymentDateModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Update Next Payment Date</h4>
      <button type="button" class="close" aria-label="Close" (click)="modalService.dismissAll()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label>Next Payment Date</label>
        <input
          type="date"
          class="form-control"
          [(ngModel)]="editNextPaymentDate"
          [min]="minNextPaymentDate"
        />
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="saveNextPaymentDate()">Save</button>
    </div>
  </ng-template>
</div>

<!------------- Popup For Date of Joining --------------------------------------->
<div>
  <ng-template #dateOfJoiningModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Update Date of Joining</h4>
      <button type="button" class="close" aria-label="Close" (click)="modalService.dismissAll()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label>Date of Joining</label>
        <input
          type="date"
          class="form-control"
          [(ngModel)]="editDateOfJoining"
        />
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="saveDateOfJoining()">Save</button>
    </div>
  </ng-template>
</div>

<!------------- Popup For Notes --------------------------------------->
<div>
  <ng-template #notesModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Update {{ currentNoteType | titlecase }}</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <textarea class="form-control" [(ngModel)]="editNoteValue" rows="4"></textarea>
    </div>
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
      <button class="btn btn-primary" (click)="saveNote()">Save</button>

    </div>
  </ng-template>
</div>

<!------------- Popup For Student Relationship --------------------------------------->
<div>
  <ng-template #studentRelationshipModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Select Student Relationship</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label>Student Relationship</label>
        <ng-select
          [items]="studentRelationshipTags"
          bindLabel="displayname"
          bindValue="_id"
          placeholder="Select Relationship"
          [clearable]="true"
          [searchable]="true"
          [(ngModel)]="selectedStudentRelationshipTag"
          [ngModelOptions]="{ standalone: true }"
          [appendTo]="'body'"
          class="student-relationship-select">
        </ng-select>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="saveStudentRelationshipTag()">Save</button>
    </div>
  </ng-template>
</div>

<!------------- Popup For Enrollment Tags --------------------------------------->
<div>
  <ng-template #enrollmentTagsModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Select Enrollment Tags</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label>Enrollment Tags</label>
        <ng-select
          [items]="enrollmentTags"
          bindLabel="displayname"
          bindValue="_id"
          placeholder="Select Enrollment Tags"
          [multiple]="true"
          [clearable]="true"
          [searchable]="true"
          [(ngModel)]="selectedEnrollmentTags"
          [ngModelOptions]="{ standalone: true }"
          [appendTo]="'body'"
          class="enrollment-tags-select">
        </ng-select>
      </div>
      
      <!-- Display selected tags as chips -->
      <div *ngIf="selectedEnrollmentTags && selectedEnrollmentTags.length > 0" class="mt-3">
        <label>Selected Tags:</label>
        <div class="d-flex flex-wrap">
          <span *ngFor="let tagId of selectedEnrollmentTags" 
                class="badge badge-pill mr-1 mb-1"
               >
            {{ getEnrollmentTagName(tagId) }}
            <i class="ft-x ml-1 cursor-pointer" (click)="removeEnrollmentTagFromModal(tagId)"></i>
          </span>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="saveEnrollmentTags()">Save</button>
    </div>
  </ng-template>
</div>

<!-- Modal Template (place at the end of your HTML file) -->
<ng-template #courseUpdateModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Update Course</h4>
    <button type="button" class="close" aria-label="Close" (click)="modalService.dismissAll()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <label>Select Course</label>
      <select class="form-control" [(ngModel)]="selected_course">
        <option *ngFor="let course of course_list" [value]="course._id">
          {{ course.title }} <span *ngIf="course.duration?.displayname">| {{ course.duration.displayname }}</span>
        </option>
      </select>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="saveCourseUpdate()">Save</button>
  </div>
</ng-template>